import classNames from "classnames";
import React from "react";

type CircleSize = "big" | "normal" | "small";

export type IconType =
    "cancel" | "closed" | "checked" | "envelope" | "hourglass" | "info" | "layers" | "paperclip" | "message";

const getBadge = (count: number, badge: string): JSX.Element => {
  const className = (badge === "alert") ? "badge-alert" : "badge";
  return count !== 0 && <span className={className}>{count}</span>;
};

interface ICircleWithBadgeProps {
  icon: IconType
  count?: number
  title?: string
  badge?: "regular" | "alert" | "black"
}

interface ICircleProps {
  hoverable?: true
  icon: IconType
  size?: CircleSize
  title?: string
  transparent?: boolean
}

const iconClasses: { [T in IconType]: string; } = {
  cancel: "icon-cancel",
  checked: "icon-checked",
  closed: "icon-cancel-1",
  envelope: "icon-envelope",
  hourglass: "icon-hourglass",
  info: "icon-info-letter",
  layers: "icon-layers",
  message: "icon-speech-bubble-right",
  paperclip: "icon-paperclip"
};

const getIconClass = (icon: IconType): string => iconClasses[icon];

export const Circle = ({ hoverable, size, title, icon, transparent, ...rest }: ICircleProps) => {
  const classes = classNames("circle-icon",
    size,
    icon,
    { s1_transparent: transparent },
    { hoverable });

  return (<div className={classes} title={title} {...rest}>
    <i className={getIconClass(icon)} />
  </div>
  );
};

export const CircleWithBadge = (props: ICircleWithBadgeProps) => (
  <div>
    <div className="badge-container">
      <Circle size="big"
        icon={props.icon}
        transparent={props.count === 0}
        title={props.title} />
      {getBadge(props.count, props.badge)}
    </div>
  </div>
);
